<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>{{pageHeader}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goToLandingPage()">
        <ion-icon slot="icon-only" name="home"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>


<ion-content class="ion-content">
  <ion-tabs #my_profile_tabs>
    <ion-tab-bar slot="top" color="primary" *ngIf="!IsAdminLogin">
      <ion-tab-button tab="me-tab">
        <ion-icon name="person"></ion-icon>
        <ion-label>{{ME}}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="team-tab" *ngIf=IsPSMLogin>
        <ion-icon name="people"></ion-icon>
        <ion-label>팀</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="summary-tab" *ngIf=IsPSMLogin>
        <ion-icon name="people"></ion-icon>
        <ion-label>{{Summary}}</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</ion-content>